import { ReactNode } from "react";
import Logo from "assets/images/logo_poder_judicial.png";

import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useAuthStore } from "hooks/useAuthStore";
import BalanceIcon from "@mui/icons-material/Balance";
import { Button } from "@mui/material";

interface PropsInterface {
  children: ReactNode;
  title: string;
}

export const AuthLayout = ({ children, title }: PropsInterface) => {
  const { imagenHora, changeIsNorma } = useAuthStore();

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: imagenHora
            ? `url(${require(`assets/images/tribunal-${imagenHora}.jpg`)})`
            : `url(${require("assets/images/tribunal-dia.jpg")})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[100]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 4,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          {title === "Iniciar Sesión" ? (
            <>
              <div className="justify-end">
                <Button
                  type="button"
                  variant="contained"
                  startIcon={<BalanceIcon />}
                  color="error"
                  onClick={() => changeIsNorma(true)}
                >
                  NORMATIVIDAD
                </Button>
              </div>
            </>
          ) : null}
        </Box>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={Logo} width="100" className="mb-6" alt="logo" />

          <Typography
            component="h1"
            variant="h5"
            className="my-4"
            sx={{ fontSize: "30px", marginY: "10px" }}
          >
            Tribunal Electrónico
          </Typography>
          <Typography component="h1" variant="h5" className="my-4">
            {title}
          </Typography>
          <Box component="div" sx={{ mt: 6 }}>
            {children}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
